import { Discount } from '../../types/DiscountTypes'
import {
  fixMathRounding,
  getActivitiesForRegisteredPartners,
  getActivitiesWithDiscountId,
  getPriceFromCalculation,
  getBasePriceFromCalculation
} from './CalculateDiscountHelpers'
import {
  CalculateDiscountLogic,
  Calculation,
  CalculationDiscount,
  CalculationUserInput,
  DiscountType
} from './CalculateDiscountTypes'

export class CouplesDiscountLogic implements CalculateDiscountLogic {
  type: DiscountType = 'couples'
  discountDefinition: Discount

  constructor(discount: Discount) {
    this.discountDefinition = discount
  }

  chooseEligible(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    return getActivitiesWithDiscountId(previousCalculations, this.discountDefinition.id)
  }

  calculate(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    // don't process if calculation is v2 (it has no registeredPartners) and participants amount is less than 2
    if (userInput.participantsAmount < 2 && !userInput.registeredPartners) return previousCalculations
    // for enrollment v3 calculation, exit if there are no activities matched for registered partners
    const partnerActivities = getActivitiesForRegisteredPartners(
      previousCalculations,
      userInput.registeredPartners || []
    )
    if (userInput.registeredPartners && partnerActivities.length === 0) return previousCalculations

    const eligibleActivities = this.chooseEligible(previousCalculations, userInput)

    previousCalculations.map((calculation) => {
      if (!eligibleActivities.includes(calculation.activity.id)) return
      const activityPrice = getPriceFromCalculation(calculation)
      const basePrice = getBasePriceFromCalculation(calculation)
      const discountAmount =
        this.discountDefinition.calculationType === 'amount'
          ? this.discountDefinition.value // amount discount
          : fixMathRounding(basePrice * (this.discountDefinition.value / 100)) // percentage discount on base price
      const couplesDiscount: CalculationDiscount = {
        type: this.type,
        name: this.discountDefinition.name,
        id: this.discountDefinition.id,
        input: activityPrice,
        discount: discountAmount,
        output: fixMathRounding(activityPrice - discountAmount),
        discountCalculationType: this.discountDefinition.calculationType,
        discountValue: this.discountDefinition.value,
        discountGroup: this.discountDefinition.discountGroup
      }
      calculation.discounts = calculation.discounts || []
      calculation.discounts.push(couplesDiscount)
      calculation.finalPrice = couplesDiscount.output
    })

    return previousCalculations
  }
}
